/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
App.Signature = class Signature {
  constructor(selector) {
    this.selector = selector;
    this.form = $(this.selector).closest('form');
    this.canvas = $(this.selector).get(0);
  }

  render() {
    const _this = this;
    this.signaturePad = new SignaturePad.default(this.canvas);
    this.signaturePad.addEventListener('endStroke', () => _this.updateField());

    this.resizeCanvas();
  }

  resizeCanvas() {
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    this.canvas.width = this.canvas.offsetWidth * ratio;
    this.canvas.height = this.canvas.offsetHeight * ratio;
    this.canvas.getContext('2d').scale(ratio, ratio);
  }

  clear() {
    this.signaturePad.clear();
    return this.updateField();
  }

  undo() {
    const data = this.signaturePad.toData();
    if (data) {
      data.pop();
      this.signaturePad.fromData(data);
      return this.updateField();
    }
  }

  updateField() {
    return this.form.find('input#signature_base64_data').val(
      this.signaturePad.toDataURL()
    );
  }
};

$(document).ready(function() {
  if (!$('[data-behavior~=signature-pad]').length) { return; }
  const signaturePad = new App.Signature('[data-behavior~=signature-pad]');
  signaturePad.render();

  $(window).resize(() => signaturePad.resizeCanvas());

  $('#waiver-modal').on('open.zf.reveal', () => // 500: duration of motion-ui effects when opening the modal
  window.setTimeout(function() {
    signaturePad.resizeCanvas();
  }, 500));

  $('[data-action=clear-signature]').click(function(e) {
    signaturePad.clear();
    return e.preventDefault();
  });

  return $('[data-action=undo-signature]').click(function(e) {
    signaturePad.undo();
    return e.preventDefault();
  });
});
